import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteAccountUserFragment = { __typename?: 'AccountUser', id: string, avatarColor?: Types.AvatarColor | null, accountUserType?: Types.AccountUserTypeEnum | null, deactivatedAt?: string | null, email?: string | null, accountJoinedVia: Types.AccountUserJoinedViaEnum, deletedAt?: string | null, displayAccountUserType?: string | null, displayName?: string | null, displayStatus?: string | null, inviteEmailAddress?: string | null, isDeactivated: boolean, isPending: boolean, licenseType?: Types.AccountUserLicenseTypeValue | null, status?: Types.AccountUserStatusEnum | null, userLastActiveAt?: string | null, name?: string | null, profileImageUrl?: string | null, timezone?: any | null, userId?: string | null, insertedAt?: string | null, profile?: { __typename?: 'UserProfile', jobTitle?: string | null, organizationName?: string | null } | null };

export const CompleteAccountUser = /*#__PURE__*/ gql`
    fragment CompleteAccountUser on AccountUser {
  id
  avatarColor
  accountUserType
  deactivatedAt
  email
  accountJoinedVia
  deletedAt
  displayAccountUserType @client
  displayName @client
  displayStatus @client
  insertedAt: accountJoinedAt
  inviteEmailAddress
  isDeactivated
  isPending
  licenseType
  status
  userLastActiveAt
  name
  profile {
    jobTitle
    organizationName
  }
  profileImageUrl
  timezone
  userId
}
    ` as unknown as DocumentNode<CompleteAccountUserFragment, unknown>;

        

        
export const useCompleteAccountUserFragment = (
  input: string | Omit<UseFragmentOptions<CompleteAccountUserFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AccountUser' } };
    return input;
  })();

  return useFragment<CompleteAccountUserFragment>({
    fragment: CompleteAccountUser,
    fragmentName: 'CompleteAccountUser',
    ...options,
  });
};
  
        